import fetchAPI from '../../../../common/fetchAPI'
import useError from '../../../../common/hooks/useError'
import CheckboxInput from '../../../../components/common/data-form/CheckboxInput'
import Break from '../../../../components/common/Break'
import ErrorMessage from '../../../../components/common/ErrorMessage'

export default function EnableContactFormSetting({ user, userMutate }) {
    const [error, setError] = useError()

    async function handleEnableContactFormsChange(value) {
        setError('')

        const { error } = await fetchAPI(
            `/v1/users/${user.id}`,
            { enableContactForms: value },
            'PATCH',
        )

        if (error) {
            setError(error)
            return
        }

        userMutate()
    }

    return (
        <>
            {!!error && (
                <ErrorMessage section onDismiss={() => setError('')}>
                    {error}
                </ErrorMessage>
            )}
            <CheckboxInput
                value={user.enableContactForms ?? false}
                id="enable-forms"
                label="Enable contact forms"
                onChange={handleEnableContactFormsChange}
            />
            <Break />
        </>
    )
}
